import React from "react";
import Link from "gatsby-link";
import Container from "./container";

const Footer = props => (
  <footer className="footer">
    <Container>
        <div className="footer-section">
          <h3>Navigation</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/consulting">Consulting</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>


        <div className="footer-section">
          <h3>Contact</h3>

          <ul>
            <li>
              E-mail: <br />
              info@webbholding.me
            </li>
          </ul>
        </div>


        <div className="footer-section">
          <h3>Members of Holding</h3>
          <ul>
            {props.projects.map(({ name, title }) => {
              if(title === "Mobile Development") {
                return null;
              }

              return <li key={name}><b>{title}</b><br />{name}</li>;
            })}
          </ul>
        </div>

        <div className="footer-section">
          <h3>Subscribe</h3>

          <div className="subscription-form">
            <input type="email" placeholder="Type your mail..." />
            <button>Subscribe</button>
          </div>

          <img src="/static/logo-white.png" />
        </div>
    </Container>

    <div className="footer-container-wide">
      <div className="copyrights">
        &copy; 2018 WebbHolding inc.
      </div>

      <div className="social-media">
        <i className="fas fa-facebook" />
        <i className="fas fa-twitter" />
        <i className="fas fa-google-plus" />
        <i className="fas fa-instagram" />
      </div>
    </div>

  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js